import { type ItemSizePredictor } from '@blaze-runtime/engine-ui-feature';

export class TableItemHeightPredictor implements ItemSizePredictor<any> {
  // TODO
  // This method should try to predict height of a row based on the data (item)
  // Most likely font size, styling, padding and columns width should be included
  getPredictedSize(_item: any, _index: number): number {
    return 50;
  }
}
